import Layout from '@/layout'
// import routerView from '@/layout/routerView.vue'
const approvalRouter = {
  path: '/approval',
  component: Layout,
  redirect: '/approval/index',
  name: 'approval',
  hidden: true,
  meta: {
    title: '审批中心',
    icon: 'approve'
  },
  children: [
    {
      path: 'index',
      component: () => import('@/views/oldProcess/page/list.vue'),
      name: 'ApprovalRule',
      meta: { title: '审批规则设置' }
    },

    // {
    //   path: 'rule',
    //   meta: {
    //     title: '审批规则设置'
    //   },
    //   hidden: true,
    //   redirect: '/approval/index',
    //   component: routerView,
    //   children: [
    //     {
    //       path: 'edit',
    //       component: () => import('@/views/approvalCenter/page/creatRule.vue'),
    //       name: 'editRule',
    //       meta: { title: '编辑审批', activeMenu: '/approval/index' }
    //     },
    //     {
    //       path: 'create',
    //       component: () => import('@/views/oldProcess/page/add.vue'),
    //       name: 'createRule',
    //       meta: { title: '新建审批', activeMenu: '/approval/index' }
    //     }
    //   ]
    // },
    // {
    //   path: 'createRule',
    //   component: () => import('@/views/approvalCenter/page/creatRule.vue'),
    //   name: 'createRule',
    //   meta: { title: '新建审批', activeMenu: '/approval/index' },
    //   hidden: true
    // },
    // {
    //   path: 'editRule',
    //   component: () => import('@/views/approvalCenter/page/creatRule.vue'),
    //   name: 'editRule',
    //   meta: { title: '编辑审批', activeMenu: '/approval/index' },
    //   hidden: true
    // },
    // {
    //   path: 'center',
    //   component: () => import('@/views/approvalCenter/page/center.vue'),
    //   name: 'ApprovalCenter',
    //   meta: { title: '审批中心' },
    //   hidden: true
    // },
    {
      path: 'add',
      component: () => import('@/views/oldProcess/page/add.vue'),
      name: 'ApprovalAdd',
      hidden: true,
      meta: { title: '新建流程', activeMenu: '/oldProcess/list' }
    },
    {
      path: 'edit',
      component: () => import('@/views/oldProcess/page/add.vue'),
      name: 'ApprovalAdd',
      hidden: true,
      meta: { title: '编辑流程', activeMenu: '/oldProcess/list' }
    },
    {
      path: 'myApprovalList',
      component: () => import('@/views/approvalCenter/page/myApprovalList.vue'),
      name: 'MyApprovalList',
      meta: { title: '审批列表', activeMenu: '/home/index', dynamicTitle: 'dynamicTitle' }, // 动态title,匹配url上相同字段
      hidden: true
    }
    // {
    //   path: 'index2',
    //   component: () => import('@/views/profession/page/list.vue'),
    //   name: 'ApprovalRule',
    //   meta: { title: '专业版审批规则设置测试', isInFrame: true }
    // },
    // {
    //   path: 'add2',
    //   component: () => import('@/views/profession/page/add.vue'),
    //   name: 'ApprovalAdd2',
    //   hidden: true,
    //   meta: { title: '专业版新建流程测试', activeMenu: '/profession/list', isInFrame: true }
    // },
    // {
    //   path: 'edit2',
    //   component: () => import('@/views/profession/page/add.vue'),
    //   name: 'ApprovalAdd2',
    //   hidden: true,
    //   meta: { title: '专业版编辑流程测试', activeMenu: '/profession/list', isInFrame: true }
    // }
  ]
}
export default approvalRouter
